import { IntegrationSystem } from '@/shared/types';

import { dictionary, permits, services, common } from './endpoints';
import { ars, bia, erz, iac, pay, rmp, rmpc, wnt } from './integrations';

const api = {
  ...common,

  services,
  permits,
  dictionary,

  [IntegrationSystem.ERZ]: erz,
  [IntegrationSystem.WNT]: wnt,
  [IntegrationSystem.IAC]: iac,
  [IntegrationSystem.PAY]: pay,
  [IntegrationSystem.ARS]: ars,
  [IntegrationSystem.RMP]: rmp,
  [IntegrationSystem.RMPC]: rmpc,
  [IntegrationSystem.BIA]: bia,
};

export default api;
